/**
 * Enhanced Search for Shopify
 * 
 * Este script mejora la funcionalidad de búsqueda en la tienda Shopify:
 * - Normaliza términos de búsqueda eliminando espacios
 * - Permite encontrar productos incluso cuando los términos de búsqueda están combinados
 */

window.enhancedSearch = (function() {
  // Identificador único para verificar carga
  console.log('Enhanced Search v1.0.0 - REI Cosmetics - ' + new Date().toISOString());

  // Función para normalizar términos de búsqueda
  function normalizeSearchTerm(term) {
    if (!term) return '';
    return term.toLowerCase().trim().replace(/\s+/g, '');
  }

  // Interceptar solicitudes de búsqueda predictiva
  function setupPredictiveSearch() {
    try {
      // Guardar referencia al fetch original
      const originalFetch = window.fetch;

      // Reemplazar fetch con nuestra versión mejorada
      window.fetch = function(resource, options) {
        // Verificar si es una solicitud de búsqueda predictiva
        if (typeof resource === 'string' && resource.includes('/search/suggest.json')) {
          console.log('Enhanced Search: Interceptando búsqueda predictiva');
          
          try {
            // Obtener el término de búsqueda original
            const url = new URL(resource, window.location.origin);
            const originalTerm = url.searchParams.get('q');
            
            if (originalTerm) {
              console.log('Enhanced Search: Término original: "' + originalTerm + '"');
              
              // Crear término normalizado (sin espacios)
              const normalizedTerm = normalizeSearchTerm(originalTerm);
              
              // Si el término normalizado es diferente, modificar la búsqueda
              if (normalizedTerm !== originalTerm && normalizedTerm.length > 0) {
                console.log('Enhanced Search: Término normalizado: "' + normalizedTerm + '"');
                
                // Modificar la URL para usar el término normalizado
                url.searchParams.set('q', normalizedTerm);
                
                // Realizar la solicitud con el término modificado
                return originalFetch(url.toString(), options);
              }
            }
          } catch (error) {
            console.error('Enhanced Search: Error:', error);
          }
        }
        
        // Para otras solicitudes, usar el fetch original
        return originalFetch(resource, options);
      };
      
      console.log('Enhanced Search: Búsqueda predictiva mejorada configurada');
    } catch (error) {
      console.error('Enhanced Search: Error al configurar búsqueda predictiva:', error);
    }
  }

  // Mejorar formularios de búsqueda
  function enhanceSearchForms() {
    try {
      // Esperar a que el DOM esté listo
      document.addEventListener('DOMContentLoaded', function() {
        console.log('Enhanced Search: Mejorando formularios de búsqueda');
        
        // Buscar todos los formularios de búsqueda
        const searchForms = document.querySelectorAll('form[action*="/search"]');
        
        if (searchForms.length === 0) {
          console.log('Enhanced Search: No se encontraron formularios de búsqueda');
          return;
        }
        
        console.log('Enhanced Search: Encontrados ' + searchForms.length + ' formularios de búsqueda');
        
        // Mejorar cada formulario
        searchForms.forEach(function(form, index) {
          console.log('Enhanced Search: Mejorando formulario #' + (index + 1));
          
          form.addEventListener('submit', function(event) {
            const searchInput = form.querySelector('input[name="q"]');
            
            if (searchInput && searchInput.value) {
              console.log('Enhanced Search: Búsqueda enviada: "' + searchInput.value + '"');
            }
          });
        });
      });
    } catch (error) {
      console.error('Enhanced Search: Error al mejorar formularios:', error);
    }
  }

  // Inicializar
  function init() {
    console.log('Enhanced Search: Inicializando...');
    setupPredictiveSearch();
    enhanceSearchForms();
    console.log('Enhanced Search: Inicialización completa');
    return {
      version: '1.0.0',
      normalizeSearchTerm: normalizeSearchTerm
    };
  }

  // Devolver API pública
  return init();
})();
